// SEO helper function to generate robots, canonical, and hreflang data
export const generateSEOData = (pageType, locale, slug = '') => {
    const baseUrl = 'https://www.tiliana.hu'

    // Define SEO data for different page types
    const seoData = {
        // Főoldal (Home)
        'home': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}` },
                    { hreflang: 'en', href: `${baseUrl}/en` },
                    { hreflang: 'x-default', href: `${baseUrl}/en` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}` },
                    { hreflang: 'en', href: `${baseUrl}/en` },
                    { hreflang: 'x-default', href: `${baseUrl}/en` }
                ]
            }
        },

        // Étterem (Restaurant)
        'etalon': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/etalon`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/etalon` },
                    { hreflang: 'en', href: `${baseUrl}/en/etalon/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/etalon/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/etalon/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/etalon` },
                    { hreflang: 'en', href: `${baseUrl}/en/etalon/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/etalon/` }
                ]
            }
        },

        // Wellness
        'wellness': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/szolgaltatasok/wellness`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szolgaltatasok/wellness` },
                    { hreflang: 'en', href: `${baseUrl}/en/services/wellness/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/services/wellness/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/services/wellness/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szolgaltatasok/wellness` },
                    { hreflang: 'en', href: `${baseUrl}/en/services/wellness/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/services/wellness/` }
                ]
            }
        },

        // Medencehasználat (Pool Usage)
        'poolusage': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/szolgaltatasok/medencehasznalat/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szolgaltatasok/medencehasznalat/` },
                    { hreflang: 'en', href: `${baseUrl}/en/services/pool-use/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/services/pool-use/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/services/pool-use/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szolgaltatasok/medencehasznalat/` },
                    { hreflang: 'en', href: `${baseUrl}/en/services/pool-use/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/services/pool-use/` }
                ]
            }
        },

        // Szobáink (Rooms)
        'rooms': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/szobak/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/rooms/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms/` }
                ]
            }
        },

        // Standard Franciaágyas (Standard Double Room)
        'room': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/szobak/standard-franciaagyas/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/standard-franciaagyas/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms/standard-double-room/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms/standard-double-room/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/rooms/standard-double-room/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/standard-franciaagyas/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms/standard-double-room/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms/standard-double-room/` }
                ]
            }
        },

        // Superior Kétágyas (Superior Double)
        'superior-double': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/szobak/superior-ketagyas/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/superior-ketagyas/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms/superior-double/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms/superior-double/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/rooms/superior-double/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/superior-ketagyas/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms/superior-double/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms/superior-double/` }
                ]
            }
        },

        // Homoky Lakosztály (Homoky Suite)
        'homoky-suite': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/szobak/homoky-lakosztaly/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/homoky-lakosztaly/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms/homoky-suite/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms/homoky-suite/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/rooms/homoky-suite/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/szobak/homoky-lakosztaly/` },
                    { hreflang: 'en', href: `${baseUrl}/en/rooms/homoky-suite/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/rooms/homoky-suite/` }
                ]
            }
        },

        // Rólunk (About)
        'about': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/rolunk/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rolunk/` },
                    { hreflang: 'en', href: `${baseUrl}/en/about/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/about/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/about/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rolunk/` },
                    { hreflang: 'en', href: `${baseUrl}/en/about/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/about/` }
                ]
            }
        },

        // Hírek (News)
        'news': {
            hu: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/hirek/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/hirek/` },
                    { hreflang: 'en', href: `${baseUrl}/en/news/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/news/` }
                ]
            },
            en: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/en/news/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/hirek/` },
                    { hreflang: 'en', href: `${baseUrl}/en/news/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/news/` }
                ]
            }
        },

        // Események (Events)
        'events': {
            hu: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/esemenyek/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/esemenyek/` },
                    { hreflang: 'en', href: `${baseUrl}/en/events/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/events/` }
                ]
            },
            en: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/en/events/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/esemenyek/` },
                    { hreflang: 'en', href: `${baseUrl}/en/events/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/events/` }
                ]
            }
        },

        // Házirend (Policy)
        'rules': {
            hu: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/hazirend/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/hazirend/` },
                    { hreflang: 'en', href: `${baseUrl}/en/policy/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/policy/` }
                ]
            },
            en: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/en/policy/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/hazirend/` },
                    { hreflang: 'en', href: `${baseUrl}/en/policy/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/policy/` }
                ]
            }
        },

        // Családi nap (Family Day)
        'familyday': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/rendezveny/csaladi-napok/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/csaladi-napok/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/family-reunion/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/family-reunion/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/gatherings/family-reunion/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/csaladi-napok/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/family-reunion/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/family-reunion/` }
                ]
            }
        },

        // Születésnap (Birthday)
        'birthday': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/rendezveny/szuletesnap/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/szuletesnap/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/birthday-celebration/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/birthday-celebration/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/gatherings/birthday-celebration/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/szuletesnap/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/birthday-celebration/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/birthday-celebration/` }
                ]
            }
        },

        // Konferencia (Conference)
        'conference': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/rendezveny/konferencia/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/konferencia/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/conference/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/conference/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/gatherings/conference/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/konferencia/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/conference/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/conference/` }
                ]
            }
        },

        // Esküvő (Wedding)
        'wedding': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/rendezveny/eskuvo/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/eskuvo/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/last-minute-wedding` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/last-minute-wedding` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/gatherings/last-minute-wedding/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/eskuvo/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/last-minute-wedding/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/last-minute-wedding/` }
                ]
            }
        },

        // Gyerekzsúr (Kids Party)
        'kidparty': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/rendezveny/gyerekzsur/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/gyerekzsur/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/kids-party/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/kids-party/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/gatherings/kids-party/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/gyerekzsur/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/kids-party/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/kids-party/` }
                ]
            }
        },

        // Karácsonyi Rendezvények (Xmas Events)
        'xmasevents': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/rendezveny/karacsonyi-rendezvenyek/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/karacsonyi-rendezvenyek/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/xmas-events/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/xmas-events/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/gatherings/xmas-events/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/rendezveny/karacsonyi-rendezvenyek/` },
                    { hreflang: 'en', href: `${baseUrl}/en/gatherings/xmas-events/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/gatherings/xmas-events/` }
                ]
            }
        },

        // Kapcsolat (Contact)
        'contact': {
            hu: {
                robots: 'index, follow',
                canonical: `${baseUrl}/kapcsolat/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/kapcsolat/` },
                    { hreflang: 'en', href: `${baseUrl}/en/contact/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/contact/` }
                ]
            },
            en: {
                robots: 'index, follow',
                canonical: `${baseUrl}/en/contact/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/kapcsolat/` },
                    { hreflang: 'en', href: `${baseUrl}/en/contact/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/contact/` }
                ]
            }
        }
    }

    // Career pages (all with noindex, follow)
    const careerPages = [
        'carrier-event-manager',
        'carrier-waiter',
        'carrier-front-office-manager',
        'carrier-deputy-chef',
        'carrier-receptionist',
        'carrier-janitor',
        'carrier-maid',
        'carrier-kitchen-worker'
    ]

    if (careerPages.includes(pageType)) {
        const careerSlugs = {
            'carrier-event-manager': { hu: 'rendezvenyszervezo', en: 'event-manager' },
            'carrier-waiter': { hu: 'felszolgalo', en: 'waiter' },
            'carrier-front-office-manager': { hu: 'front-office-manager', en: 'front-office-manager' },
            'carrier-deputy-chef': { hu: 'konyhafonok-helyettes', en: 'deputy-chef' },
            'carrier-receptionist': { hu: 'recepcios', en: 'receptionist' },
            'carrier-janitor': { hu: 'karbantarto', en: 'janitor' },
            'carrier-maid': { hu: 'szobalany', en: 'maid' },
            'carrier-kitchen-worker': { hu: 'konyhai-kisegito', en: 'kitchen-worker' }
        }

        const slug = careerSlugs[pageType]

        return {
            hu: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/karrierek/${slug.hu}/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/karrierek/${slug.hu}/` },
                    { hreflang: 'en', href: `${baseUrl}/en/carriers/${slug.en}/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/carriers/${slug.en}/` }
                ]
            },
            en: {
                robots: 'noindex, follow',
                canonical: `${baseUrl}/en/carriers/${slug.en}/`,
                hreflang: [
                    { hreflang: 'hu', href: `${baseUrl}/karrierek/${slug.hu}/` },
                    { hreflang: 'en', href: `${baseUrl}/en/carriers/${slug.en}/` },
                    { hreflang: 'x-default', href: `${baseUrl}/en/carriers/${slug.en}/` }
                ]
            }
        }
    }

    // Return the SEO data for the given page type and locale
    return seoData[pageType] ? seoData[pageType][locale] : null
} 